export default "__VITE_ASSET__8efaa3f6__"